// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__mLsF9","disabled":"styles_disabled__29gRq"};